// src/index.js or src/main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CssBaseline } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'; // Import adapter
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'; // Import provider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}> {/* Wrap App */}
      <CssBaseline />
      <App />
    </LocalizationProvider>
  </React.StrictMode>
);